// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2IDX-","rootSmall":"AddTileButton_rootSmall__3yrOm"};